import { getRequest, postRequest } from "../../helpers/request";

export const TYPES = {
  LOGIN_USER_START: "LOGIN_USER_START",
  LOGIN_USER_COMPLETE: "LOGIN_USER_COMPLETE",
  LOGIN_USER_ERROR: "LOGIN_USER_ERROR",

  FORGOT_PASS_EMAIL_VERIFY_START: "FORGOT_PASS_EMAIL_VERIFY_START",
  FORGOT_PASS_EMAIL_VERIFY_COMPLETE: "FORGOT_PASS_EMAIL_VERIFY_COMPLETE",
  FORGOT_PASS_EMAIL_VERIFY_ERROR: "FORGOT_PASS_EMAIL_VERIFY_ERROR",

  FORGOT_PASS_VERIFY_PASSWORD_START: "FORGOT_PASS_VERIFY_PASSWORD_START",
  FORGOT_PASS_VERIFY_PASSWORD_COMPLETE: "FORGOT_PASS_VERIFY_PASSWORD_COMPLETE",
  FORGOT_PASS_VERIFY_PASSWORD_ERROR: "FORGOT_PASS_VERIFY_PASSWORD_ERROR",

  // FETCHING_APP_ENGAGEMENT: "FETCHING_APP_ENGAGEMENT",
  FETCHED_APP_ENGAGEMENT: "FETCHED_APP_ENGAGEMENT",
  FETCHED_APP_ENGAGEMENT_ERROR: "FETCHED_APP_ENGAGEMENT_ERROR",

  LOGOUT_USER: "LOGOUT_USER",
  CLEAR_ERROR: "CLEAR_ERROR",
  SET_ALERT: "SET_ALERT",
};

export const clearAlert = () => async (dispatch) => {
  dispatch({ type: TYPES.CLEAR_ERROR });
};

export const setAlert = (error, msg) => async (dispatch) => {
  dispatch({ type: TYPES.SET_ALERT, data: { error, msg } });
};

export const getAppEngagement = () => async (dispatch) => {
  // dispatch({ type: TYPES.FETCHING_APP_ENGAGEMENT });
  try {
    const { data } = await getRequest(`app-engagement`);
    if (data.isSuccess) {
      dispatch({ type: TYPES.FETCHED_APP_ENGAGEMENT, data: data.appEngagement });
    } else {
      dispatch({ type: TYPES.FETCHED_APP_ENGAGEMENT_ERROR });
    }
  } catch (error) {
    console.log(error);
    dispatch({ type: TYPES.FETCHED_APP_ENGAGEMENT_ERROR });
  }
};

export const userLogin = (userBody) => async (dispatch) => {
  dispatch({ type: TYPES.LOGIN_USER_START });
  try {
    const { data } = await postRequest(`user/login`, userBody);

    if (data.isSuccess) {
      localStorage.setItem("name", data.name);
      localStorage.setItem("engagement", data.engagement);
      localStorage.setItem("email", data.email);
      localStorage.setItem("token", data.token);
      localStorage.setItem("refreshToken", data.refreshToken);
      localStorage.setItem("role", data.role);
      dispatch({ type: TYPES.LOGIN_USER_COMPLETE, data: data });
    } else {
      dispatch({ type: TYPES.LOGIN_USER_ERROR, data: data.msg });
    }
  } catch (error) {
    console.log(error);
    dispatch({ type: TYPES.LOGIN_USER_ERROR, msg: JSON.stringify(error) });
  }
};

export const restoreUser = (data) => async (dispatch) => {
  dispatch({ type: TYPES.LOGIN_USER_COMPLETE, data: data });
};

export const logoutUser = () => async (dispatch) => {
  localStorage.clear();
  dispatch({
    type: TYPES.LOGOUT_USER,
  });
};

export const userVerifyEmail =
  ({ userEmail }) =>
  async (dispatch) => {
    dispatch({ type: TYPES.FORGOT_PASS_EMAIL_VERIFY_START, data: userEmail });
    try {
      const { data } = await postRequest(`user/verifyEmail`, {
        email: userEmail,
      });
      if (data.isSuccess) dispatch({ type: TYPES.FORGOT_PASS_EMAIL_VERIFY_COMPLETE });
      else dispatch({ type: TYPES.FORGOT_PASS_EMAIL_VERIFY_ERROR });
      return data;
    } catch (err) {
      console.log(err);
      dispatch({ type: TYPES.FORGOT_PASS_EMAIL_VERIFY_ERROR });
      return err;
    }
  };

export const changePassword =
  ({ userEmail, password }) =>
  async (dispatch) => {
    dispatch({
      type: TYPES.FORGOT_PASS_VERIFY_PASSWORD_START,
      data: { email: userEmail, password: password },
    });
    try {
      const { data } = await postRequest(`user/changePassword`, {
        email: userEmail,
        newPassword: password,
      });
      if (data.isSuccess) dispatch({ type: TYPES.FORGOT_PASS_VERIFY_PASSWORD_COMPLETE });
      else dispatch({ type: TYPES.FORGOT_PASS_VERIFY_PASSWORD_ERROR });
      return data;
    } catch (err) {
      console.log(err);
      dispatch({ type: TYPES.FORGOT_PASS_VERIFY_PASSWORD_ERROR });
      return err;
    }
  };
